/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import parse from 'html-react-parser';

import Title from '../shared/Title';
import Text from '../shared/Text';
import { palette } from '../../constants/styles';

const FinancialStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${palette.sweetGray};
  border-radius: 15px;
  width: 95%;
  padding: 5px 15px;
  margin-top: 50px;
  z-index: 300;
`;


const OnceiaL = ({
  number, title, text, identifier, linkText, email, planLink,
}) => (
  <FinancialStep>
    <Title level={4}>
        <b>Paso {number}:</b> <span style={{ fontWeight: '500' }}>{title}</span>
      </Title>
    <Text style={{ marginBottom: '0.5em' }}>
        {parse(`${text}`)}
      </Text>
    <Link
        to={`/contacto/plan/${identifier}/${planLink}`}
        style={{
          marginTop: '10px', marginBottom: '5px', cursor: 'pointer', alignSelf: 'center', textAlign: 'center', color: palette.terciaryColor, fontWeight: '500',
        }}
      >
        {linkText}
      </Link>
  </FinancialStep>
);

export default OnceiaL;
